import styled from 'styled-components'
import { bp, font } from 'lib/core/resources/helpers/styled'
import { BREAKPOINT } from 'app/sofia/resources/constants'
import { container, link } from 'app/sofia/resources/theme/css'

export const Container = styled.div`
  ${container}
  min-height: 50vh;

  h1 {
    font: ${font('default', 'bold', '27px')};
    ${bp('sm')`
      padding: 0 20px;
    `}

    span {
      color: ${props => props.theme.palette.general.grey};
    }
  }
`

export const CartLayout = styled.div`
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;

  .cart__heading {
    text-align: left;
    font: ${font('default', 'bold', '18px/1')};
    color: ${props => props.theme.palette.general.strong};
    background: ${props => props.theme.palette.general.greyLight};
    text-transform: uppercase;
    padding: 10px;
  }
`

export const CartMain = styled.div`
  width: calc(100% - 260px);
  padding: 0 30px 0 0;
  box-sizing: border-box;

  @media (max-width: ${BREAKPOINT.MD}) {
    width: 100%;
  }

  ${bp('sm')`
    width: 100%;
    padding: 0;
  `}
`

export const CartAside = styled.div`
  background: ${props => props.theme.palette.general.soft};
  padding: 30px 15px;
  color: ${props => props.theme.palette.primary.alphaDark};
  position: sticky;
  top: 20px;
  width: 260px;
  box-sizing: border-box;
  margin-bottom: 30px;
  ${bp('sm')`
    width: 100%;
  `}
`

export const LinkWrapper = styled.div`
  a {
    display: inline-block;
    font: ${font('default', 'bold', '18px/1.5')};
    ${link}
    text-decoration: none;
    padding: 15px 0;
  }
`
